<form #formRegisterDetails="ngForm" name="formRegisterDetails" (submit)="handleSubmitRegisterDetails(formRegisterDetails.value, $event)" novalidate>
  <h3 class="text-dark-blue">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>
  <p class="text-dark-blue">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>
  <div class="row">
    <div class="col-xs-4">
      <div class="form-group with-select">
        <select class="form-control no-label"
                [ngClass]="{ 'has-error' : UserTitle.invalid && UserTitle.dirty }"
                id="UserTitle"
                name="UserTitle"
                #UserTitle="ngModel"
                ngModel
                required>
          <option value="" disabled></option>
          <option value="Mr">{{ appCopy.panelHeader['mrOption'+selectedLanguage] }}</option>
          <option value="Ms">{{ appCopy.panelHeader['msOption'+selectedLanguage] }}</option>
          <option value="Mrs">{{ appCopy.panelHeader['mrsOption'+selectedLanguage] }}</option>
          <option value="Miss">{{ appCopy.panelHeader['missOption'+selectedLanguage] }}</option>
        </select>
        <label class="control-label" for="UserTitle">{{ appCopy.panelHeader['titlePlaceholder'+selectedLanguage] }}</label>
        <p class="help-block text-danger" *ngIf="UserTitle.invalid && UserTitle.dirty">{{ appCopy.panelHeader['userTitleWarning'+selectedLanguage] }}</p>
      </div>
    </div>
    <div class="col-xs-8">
      <div class="form-group">
        <input class="form-control"
              [ngClass]="{ 'has-error' : UserFirstName.invalid && UserFirstName.dirty }"
              id="UserFirstName"
              name="UserFirstName"
              pattern="^[a-zA-Z]+(?: [a-zA-Z]+)*"
              type="text"
              #UserFirstName="ngModel"
              ngModel
              required
              appCheckEmpty>
        <label class="control-label" for="UserFirstName">{{ appCopy.panelHeader['fNamePlaceholder'+selectedLanguage] }}</label>
        <i class="icon control-validation-state"></i>

        <p class="help-block text-danger" *ngIf="UserFirstName.invalid && UserFirstName.dirty && !UserFirstName.errors?.pattern">{{ appCopy.panelHeader['fNameeWarning'+selectedLanguage] }}</p>
        <p class="help-block text-danger" *ngIf="UserFirstName.errors?.pattern">{{ appCopy.panelHeader['errorTextBookerNameInvalid'+selectedLanguage] }}</p>
      </div>
    </div>
  </div>

  <div class="form-group">
    <input class="form-control"
          [ngClass]="{ 'has-error' : UserLastName.invalid && UserLastName.dirty }"
          id="UserLastName"
          name="UserLastName"
          pattern="^[a-zA-Z]+(?: [a-zA-Z]+)*"
          type="text"
          #UserLastName="ngModel"
          ngModel
          required
          appCheckEmpty>
    <label class="control-label" for="UserLastName">{{ appCopy.panelHeader['lNamePlaceholder'+selectedLanguage] }}</label>
    <i class="icon control-validation-state"></i>

    <p class="help-block text-danger" *ngIf="UserLastName.invalid && UserLastName.dirty && !UserLastName.errors?.pattern">{{ appCopy.panelHeader['lNameeWarning'+selectedLanguage] }}</p>
    <p class="help-block text-danger" *ngIf="UserLastName.errors?.pattern">{{ appCopy.panelHeader['errorTextBookerNameInvalid'+selectedLanguage] }}</p>
  </div>

  <div class="multiple-inputs clearfix">
    <div class="col-xs-4 col-sm-3 form-group with-select">
      <div class="with-select__custom-value">+{{countryCode}}</div>
      <ng-select class="form-control form-control--no-label custom"
        [ngClass]="{ 'has-error' : UserCountryCode.invalid && UserCountryCode.dirty }" id="UserCountryCode"
        name="UserCountryCode" #UserCountryCode="ngModel" [(ngModel)]="countryCode" required ngModel
        [clearable]="false"
        [items]="countryCodes.all" groupBy="label" bindLabel="displayText" bindValue="countryCode">
      </ng-select>
      <p class="help-block text-danger" *ngIf="UserCountryCode.invalid && UserCountryCode.dirty">{{ appCopy.panelHeader['countryCodeWarning'+selectedLanguage] }}</p>
    </div>
    <div class="col-xs-8 col-sm-9 form-group">
      <input class="form-control form-control--no-label"
            [ngClass]="{ 'has-error' : UserPhone.invalid && UserPhone.dirty }"
            type="tel"
            id="UserPhone"
            name="UserPhone"
            #UserPhone="ngModel"
            [pattern]="phonePattern"
            ngModel
            required
            appCheckEmpty>
      <i class="icon control-validation-state"></i>
      <p class="help-block text-danger" *ngIf="UserPhone.errors?.pattern">{{ appCopy.panelHeader['countryCodeDigitsWarning'+selectedLanguage] }}</p>
      <p class="help-block text-danger" *ngIf="UserPhone.invalid && !UserPhone.errors?.pattern && UserPhone.dirty">{{ appCopy.panelHeader['contactNumberWarning'+selectedLanguage] }}</p>
    </div>
  </div>
  <em class="help-block text-dark-blue">{{ appCopy.panelHeader['phoneNumberMessage'+selectedLanguage] }}</em>

  <!--<h6 class="margin-top-24 margin-bottom-16">Communication preferences</h6>
  <div class="checkbox checkbox--default">
    <input type="checkbox" name="subscribeNewsletter" id="subscribeNewsletter">
    <label for="subscribeNewsletter" class="text-muted">Please tick this box if you would like to receive the latest news and offers from AirPortr via email</label>
  </div>-->

  <button type="submit" class="btn btn-purple btn-lg btn-block margin-top-32" [disabled]="formRegisterDetails.invalid">
    <div class="loader-container-btn" *ngIf="showLoader">
      <div class="loader loader--white">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
    {{ appCopy.panelHeader['btnConfirm'+selectedLanguage] }}
  </button>

</form>
